import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Paper,
  TableRow,
  Table,
  Box,
} from "@mui/material";
import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import Repo from "../../Repository/Repo";
import { ClipLoader } from "react-spinners";
import { Toast } from "../components/Toast";

function ItemHistory({ onClose, item, ledger }) {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    getHistory();
  }, []);

  const getHistory = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.purchases({
        request: {
          method: "getPurchaseHistoryForItemBySupplier",
          data: {
            company_code: localStorage.getItem("companyCode"),
            item_id: item._id,
            supplier_id: ledger?._id || "",
          },
        },
      });
      setLoading(false);
      console.log("data", data);
      if (data.response.status.statusCode == 200) {
        setHistory(data.response.data.itemPurchaseHistory);
      } else {
        Toast("error", data.response.status.statusMessage);
      }
    } catch (err) {
      console.log("err:", err);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography variant="h6" sx={{ textAlign: "center", color: "#4eaf51" }}>
          {item.name} History
        </Typography>
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <ClipLoader loading={true} color="#4eaf51" size={40} />
          </Box>
        )}
        {!loading && (
          <TableContainer component={Paper} sx={{ mt: "8px" }}>
            <Table sx={{ minWidth: 550 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell> Item </TableCell>
                  <TableCell> Quantity </TableCell>
                  <TableCell> Supplier </TableCell>
                  <TableCell> Price </TableCell>
                  <TableCell> Date </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell component="th" scope="row">
                      Purchase
                    </TableCell>
                    <TableCell component="th">{row?.itemQuantity}</TableCell>
                    <TableCell component="th">{row?.supplier}</TableCell>
                    <TableCell component="th">{row?.itemPrice}</TableCell>
                    <TableCell component="th">{row?.purchaseDate}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default ItemHistory;
